import React, { useEffect, useState } from "react";
import star from "../assets/images/StarFour.png";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import axios from "axios";
import { Link } from "react-router-dom";

export const FourthSec = () => {
  const [activeWorkSectionTabs, setActiveWorkSectionTabs] = useState(0);
  const [visibleImages, setVisibleImages] = useState(6); // Initial visible images
  const [visibleAllImages, setVisibleAllImages] = useState(6); // Initial visible images for "All" tab
  const [isLoading, setIsLoading] = useState(true);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const workSection = [
    { title: "All", content: "This is the content of Tab 1" },
    { title: "UI/UX DESIGN", content: "This is the content of Tab 2" },
    { title: "LOGO & BRANDING", content: "This is the content of Tab 3" },
    { title: "ANIMATION", content: "This is the content of Tab 4" },
  ];

  const [allShuffled, setAllShuffled] = useState([]);
  const [uiux, setUiux] = useState([]);
  const [logoBranding, setLogoBranding] = useState([]);
  const [animation, setAnimation] = useState([]);

  // Handle responsive image count
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      const isMobile = window.innerWidth < 768;
      setVisibleImages(isMobile ? 4 : 6);
      setVisibleAllImages(isMobile ? 4 : 6);
    };

    handleResize(); // Set initial values
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const fetchAll = async () => {
      setIsLoading(true);
      try {
        const [uiuxRes, logoRes, animRes] = await Promise.all([
          axios.get(
            "https://brilliant-family-61fde61fa1.strapiapp.com/api/portolio-uixifies?populate=image"
          ),
          axios.get(
            "https://brilliant-family-61fde61fa1.strapiapp.com/api/logo-and-branding-uixifies?populate=image"
          ),
          axios.get(
            "https://brilliant-family-61fde61fa1.strapiapp.com/api/animation-uixifies?populate=image"
          ),
        ]);

        const allData = [
          ...uiuxRes.data.data,
          ...logoRes.data.data,
          ...animRes.data.data,
        ];

        const uniqueData = allData.filter(
          (item, index, self) =>
            index === self.findIndex((t) => t.id === item.id)
        );

        const shuffled = uniqueData
          .map((value) => ({ value, sort: Math.random() }))
          .sort((a, b) => a.sort - b.sort)
          .map(({ value }) => value);

        setAllShuffled(shuffled);
        setUiux(uiuxRes.data.data);
        setLogoBranding(logoRes.data.data);
        setAnimation(animRes.data.data);
      } catch (err) {
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAll();
  }, []);

  const handleLoadMore = () => {
    setVisibleImages(uiux.length); // Show all UI/UX images
  };

  const handleLoadBack = () => {
    setVisibleImages(windowWidth < 768 ? 4 : 6); // Reset to initial count
    scrollToSection("blogs");
  };

  const handleLoadImgMore = () => {
    setVisibleAllImages(allShuffled.length); // Show all images in "All" tab
  };

  const handleLoadImgBack = () => {
    setVisibleAllImages(windowWidth < 768 ? 4 : 6); // Reset to initial count
    scrollToSection("blogs");
  };

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <div id="blogs" className="container px-2 m-auto py-[40px]">
        <h2 className="md:text-[90px] text-[45px] font-black uppercase size-fit">
          Creativity in <span className="text-[#7467fe]">action</span>
        </h2>
        <div>
          <div className="flex gap-2">
            {[...Array(3)].map((_, index) => (
              <img
                key={index}
                alt="Star"
                src={star}
                className="object-contain w-auto"
              />
            ))}
          </div>
          <p className="text-[16px] md:text-[18px] text-[#6f6f6f] mt-3 tracking-wide">
            Sure, anyone can claim to be creative. But at UIXIFY, we prefer to
            let our work do the talking. From sleek, intuitive design to
            jaw-dropping animations and videos that actually get watched, our
            portfolio showcases the results we're proud of.
          </p>
        </div>

        <div>
          <div className="flex justify-evenly flex-wrap mt-8">
            {workSection.map((tab, index) => (
              <button
                key={index}
                onClick={() => setActiveWorkSectionTabs(index)}
                className={`py-2 px-2 md:text-[18px] text-[10px] font-medium focus:outline-none ${
                  activeWorkSectionTabs === index
                    ? "md:text-[19px] text-[12px] bg-[#c0ff00] rounded-full font-semibold text-black scale-105 border border-black border-b-4 md:w-[243px]"
                    : "text-black hover:scale-105"
                }`}
              >
                {tab.title}
              </button>
            ))}
          </div>

          <div>
            {isLoading ? (
              <div className="flex justify-center items-center h-64">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#7366fc]"></div>
              </div>
            ) : (
              <>
                {/* ALL TAB */}
                {workSection[activeWorkSectionTabs].title === "All" && (
                  <div className="relative">
                    {allShuffled.length === 0 ? (
                      <div className="text-center py-10">No projects found</div>
                    ) : (
                      <>
                        <div
                          className="grid md:grid-cols-3 grid-cols-2 gap-3 my-5"
                          style={{
                            mask:
                              visibleAllImages < allShuffled.length
                                ? "linear-gradient(to bottom, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 40%, rgba(0,0,0,0) 95%)"
                                : "none",
                            WebkitMask:
                              visibleAllImages < allShuffled.length
                                ? "linear-gradient(to bottom, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 70%, rgba(0,0,0,0) 100%)"
                                : "none",
                          }}
                        >
                          {allShuffled
                            .slice(0, visibleAllImages)
                            .map((item, index) => {
                              const imgUrl = item?.image?.url;
                              const allAttr = item;

                              return (
                                <div
                                  key={item.id || index}
                                  className="w-full mb-4 "
                                >
                                  <div className="relative group w-full h-full overflow-hidden rounded-[15px]">
                                    <img
                                      src={
                                        imgUrl.startsWith("http")
                                          ? imgUrl
                                          : `https://brilliant-family-61fde61fa1.strapiapp.com${imgUrl}`
                                      }
                                      alt={allAttr || "Logo"}
                                      className="object-cover h-full  w-full transition-transform duration-300 group-hover:scale-105"
                                    />
                                    <div className="absolute inset-0 bg-black bg-opacity-60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 p-4">
                                      <div className="flex items-center justify-center h-full w-full">
                                        <Link
                                          to={`/project/${allAttr.slug}/${allAttr.documentId}`}
                                          rel="noopener noreferrer"
                                          className="uppercase text-[8px] md:text-[12px] text-white hover:scale-105 px-4 py-2 rounded-full flex gap-2 border-2 border-white  font-semibold bg-transparent  transition-colors"
                                        >
                                          View Project
                                        </Link>
                                      </div>
                                      <div className="absolute left-4 bottom-4 text-white text-lg font-semibold capitalize">
                                        {allAttr.title || "Untitled"}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                        </div>

                        {/* Load More/Back buttons for All tab */}

                        <div className="flex justify-center gap-4 mt-4">
                          {visibleAllImages < allShuffled.length && (
                            <button
                              onClick={handleLoadImgMore}
                              className="flex items-center p-3 bg-[#7366fc] text-white rounded-full shadow-lg transition-transform transform hover:scale-105"
                            >
                              <IoIosArrowDown className="text-[30px] md:text-[40px]" />
                            </button>
                          )}
                          {visibleAllImages > (windowWidth < 768 ? 4 : 6) && (
                            <button
                              onClick={handleLoadImgBack}
                              className="flex items-center p-3 bg-[#7366fc] text-white rounded-full shadow-lg transition-transform transform hover:scale-105"
                            >
                              <IoIosArrowUp className="text-[30px] md:text-[40px]" />
                            </button>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                )}

                {/* UI/UX DESIGN TAB */}
                {workSection[activeWorkSectionTabs].title ===
                  "UI/UX DESIGN" && (
                  <div className="relative">
                    {uiux.length === 0 ? (
                      <div className="text-center py-10">
                        No UI/UX projects found
                      </div>
                    ) : (
                      <>
                        <div
                          className="grid md:grid-cols-3 grid-cols-2 gap-3 my-5"
                          style={{
                            mask:
                              visibleImages < uiux.length
                                ? "linear-gradient(to bottom, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 40%, rgba(0,0,0,0) 95%)"
                                : "none",
                            WebkitMask:
                              visibleImages < uiux.length
                                ? "linear-gradient(to bottom, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 70%, rgba(0,0,0,0) 100%)"
                                : "none",
                          }}
                        >
                          {uiux.slice(0, visibleImages).map((item, index) => {
                            const imgUrl = item?.image?.url;
                            const uiuxAttr = item;

                            return (
                              <div
                                key={item.id || index}
                                className="relative w-full"
                              >
                                <div className="relative group w-full h-full overflow-hidden rounded-[15px]">
                                  <img
                                    src={
                                      imgUrl.startsWith("http")
                                        ? imgUrl
                                        : `https://brilliant-family-61fde61fa1.strapiapp.com${imgUrl}`
                                    }
                                    alt={uiuxAttr || "Logo"}
                                    className="object-cover h-full  w-full transition-transform duration-300 group-hover:scale-105"
                                  />
                                  <div className="absolute inset-0 bg-black bg-opacity-60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 p-4">
                                    <div className="flex items-center justify-center h-full w-full">
                                      <Link
                                        to={`/project/${uiuxAttr.slug}/${uiuxAttr.documentId}`}
                                        rel="noopener noreferrer"
                                        className="uppercase text-[8px] md:text-[12px] text-white hover:scale-105 px-4 py-2 rounded-full flex gap-2 border-2 border-white  font-semibold bg-transparent  transition-colors"
                                      >
                                        View Project
                                      </Link>
                                    </div>
                                    <div className="absolute left-4 bottom-4 text-white text-lg font-semibold capitalize">
                                      {uiuxAttr.title || "Untitled"}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>

                        {/* Load More/Back buttons for UI/UX tab */}
                        <div className="flex justify-center gap-4 mt-4">
                          {visibleImages < uiux.length && (
                            <button
                              onClick={handleLoadMore}
                              className="flex items-center p-3 bg-[#7366fc] text-white rounded-full shadow-lg transition-transform transform hover:scale-105"
                            >
                              <IoIosArrowDown className="text-[30px] md:text-[40px]" />
                            </button>
                          )}
                          {visibleImages > (windowWidth < 768 ? 4 : 6) && (
                            <button
                              onClick={handleLoadBack}
                              className="flex items-center p-3 bg-[#7366fc] text-white rounded-full shadow-lg transition-transform transform hover:scale-105"
                            >
                              <IoIosArrowUp className="text-[30px] md:text-[40px]" />
                            </button>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                )}

                {/* LOGO & BRANDING TAB */}
                {workSection[activeWorkSectionTabs].title ===
                  "LOGO & BRANDING" && (
                  <div>
                    {logoBranding.length === 0 ? (
                      <div className="text-center py-10">
                        No logo & branding projects found
                      </div>
                    ) : (
                      <>
                        <div
                          className="grid md:grid-cols-3 grid-cols-2 gap-3 my-5"
                          // style={{
                          //   mask:
                          //     visibleImages < animation.length
                          //       ? "linear-gradient(to bottom, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 40%, rgba(0,0,0,0) 95%)"
                          //       : "none",
                          //   WebkitMask:
                          //     visibleImages < animation.length
                          //       ? "linear-gradient(to bottom, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 70%, rgba(0,0,0,0) 100%)"
                          //       : "none",
                          // }}
                        >
                          {logoBranding.map((item) => {
                            const attr = item;
                            const imgUrl = item?.image?.url;
                            return (
                              <div key={item.id} className="w-full">
                                {imgUrl ? (
                                  <div className="relative group w-full h-full overflow-hidden rounded-[15px]">
                                    <img
                                      src={
                                        imgUrl.startsWith("http")
                                          ? imgUrl
                                          : `https://brilliant-family-61fde61fa1.strapiapp.com${imgUrl}`
                                      }
                                      alt={attr || "Logo"}
                                      className="object-cover h-full  w-full transition-transform duration-300 group-hover:scale-105"
                                    />
                                    <div className="absolute inset-0 bg-black bg-opacity-60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 p-4">
                                      <div className="flex items-center justify-center h-full w-full">
                                        <Link
                                          to={`/project/${attr.slug}/${attr.documentId}`}
                                          rel="noopener noreferrer"
                                          className="uppercase text-[8px] md:text-[12px] text-white hover:scale-105 px-4 py-2 rounded-full flex gap-2 border-2 border-white  font-semibold bg-transparent  transition-colors"
                                        >
                                          View Project
                                        </Link>
                                      </div>
                                      <div className="absolute left-4 bottom-4 text-white text-lg font-semibold capitalize">
                                        {attr.title || "Untitled"}
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="bg-gray-200 w-full h-48 flex items-center justify-center">
                                    No image
                                  </div>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      </>
                    )}
                  </div>
                )}

                {/* ANIMATION TAB */}
                {workSection[activeWorkSectionTabs].title === "ANIMATION" && (
                  <div className="relative">
                    {animation.length === 0 ? (
                      <div className="text-center py-10">
                        No animation projects found
                      </div>
                    ) : (
                      <>
                        <div
                          className="grid md:grid-cols-3 grid-cols-2 gap-3 my-5"
                          style={{
                            mask:
                              visibleImages < animation.length
                                ? "linear-gradient(to bottom, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 40%, rgba(0,0,0,0) 95%)"
                                : "none",
                            WebkitMask:
                              visibleImages < animation.length
                                ? "linear-gradient(to bottom, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 70%, rgba(0,0,0,0) 100%)"
                                : "none",
                          }}
                        >
                          {animation
                            .slice(0, visibleImages)
                            .map((item, index) => {
                              const imgUrl = item?.image?.url;
                              const animationAttr = item;

                              return (
                                <div
                                  key={item.id || index}
                                  className="relative w-full"
                                >
                                  <div className="relative group w-full h-full overflow-hidden rounded-[15px]">
                                    <img
                                      src={
                                        imgUrl.startsWith("http")
                                          ? imgUrl
                                          : `https://brilliant-family-61fde61fa1.strapiapp.com${imgUrl}`
                                      }
                                      alt={animationAttr || "Logo"}
                                      className="object-cover h-full  w-full transition-transform duration-300 group-hover:scale-105"
                                    />
                                    <div className="absolute inset-0 bg-black bg-opacity-60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 p-4">
                                      <div className="flex items-center justify-center h-full w-full">
                                        <Link
                                          to={`/project/${animationAttr.slug}/${animationAttr.documentId}`}
                                          rel="noopener noreferrer"
                                          className="uppercase text-[8px] md:text-[12px] text-white hover:scale-105 px-4 py-2 rounded-full flex gap-2 border-2 border-white  font-semibold bg-transparent  transition-colors"
                                        >
                                          View Project
                                        </Link>
                                      </div>
                                      <div className="absolute left-4 bottom-4 text-white text-lg font-semibold capitalize">
                                        {animationAttr.title || "Untitled"}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                        </div>

                        {/* Load More/Show Less buttons */}
                        <div className="flex justify-center gap-4 mt-4">
                          {visibleImages < animation.length && (
                            <button
                              onClick={handleLoadMore}
                              className="flex items-center p-3 bg-[#7366fc] text-white rounded-full shadow-lg transition-transform transform hover:scale-105"
                            >
                              <IoIosArrowDown className="text-[30px] md:text-[40px]" />
                            </button>
                          )}
                          {visibleImages > (windowWidth < 768 ? 4 : 6) && (
                            <button
                              onClick={handleLoadBack}
                              className="flex items-center p-3 bg-[#7366fc] text-white rounded-full shadow-lg transition-transform transform hover:scale-105"
                            >
                              <IoIosArrowUp className="text-[30px] md:text-[40px]" />
                            </button>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
